import { Chevron, Icon, useToggle } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Document from 'modules/documents/store/models/Document'

import Item from './Item'
import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  readonly: boolean
  leaveDocuments: Document[]
}

const DocumentList = ({ readonly = false, leaveDocuments }: Props) => {
  const [open, toggle] = useToggle()

  if (!leaveDocuments.length) {
    return null
  }

  return (
    <div
      className={cx('documentList', {
        open,
      })}
    >
      <div onClick={toggle(!open)} className={styles.header}>
        <div className={styles.name}>
          <Icon.Large icon="documents" />
          <span className={styles.nameContent}>
            {i18n.t('time_off.document_list.title', {
              count: leaveDocuments.length,
            })}
          </span>
        </div>
        <Chevron direction={open ? 'up' : 'down'} type="terciary" />
      </div>
      {open &&
        leaveDocuments.map((leaveDocument) => (
          <Item key={leaveDocument.attributes.id} readonly={readonly} document={leaveDocument} />
        ))}
    </div>
  )
}

export default observer(DocumentList)
